import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

const BASE_URL = "https://kkblossomschool.org/KKBlossomsWebsite/api.php";

const AdminDashboard = () => {
  const admin = localStorage.getItem("admin_id");

  const [images, setImages] = useState([]);
  const [recentUploads, setRecentUploads] = useState([]);
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [category, setCategory] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [message, setMessage] = useState("");

  const [faculty, setFaculty] = useState([]);
  const [facultyFile, setFacultyFile] = useState(null);
  const [facultyName, setFacultyName] = useState("");
  const [facultyRole, setFacultyRole] = useState("");
  const [facultyType, setFacultyType] = useState("teaching");
  const [facultyRefresh, setFacultyRefresh] = useState(Date.now());
  const [facultySubject, setFacultySubject] = useState("");
  const [facultyDescription, setFacultyDescription] = useState("");
  const [facultyQualification, setFacultyQualification] = useState("");
  const [celebrations, setCelebrations] = useState([]);
  const [celebrationFile, setCelebrationFile] = useState(null);

  const fetchCelebrations = async () => {
    try {
      const res = await axios.get(`${BASE_URL}?action=getCelebrations`);
      setCelebrations(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const fileInputRef = useRef(null);

  const [banner, setBanner] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerHeading, setBannerHeading] = useState("");
  const [bannerDescription, setBannerDescription] = useState("");

  const fetchBanner = async () => {
    try {
      const res = await axios.get(`${BASE_URL}?action=getHomeBanner`);
      console.log("Banner Response:", res.data);
      if (res.data.status === "success") {
        setBanner({ ...res.data.banner });
        setBannerHeading(res.data.banner.heading);
        setBannerDescription(res.data.banner.description);
      } else {
        setBanner(null);
        setBannerHeading("");
        setBannerDescription("");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!admin) {
      window.location.href = "/admin-login";
    } else {
      fetchImages();
      fetchRecentUploads();
      fetchFaculty();
      fetchBanner();
      fetchCelebrations();
    }
  }, []);

  const handleCelebrationUpload = async () => {
    if (!celebrationFile) {
      alert("Select image");
      return;
    }
    const formData = new FormData();
    formData.append("image", celebrationFile);
    try {
      const res = await axios.post(
        `${BASE_URL}?action=uploadCelebration`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data.status === "success") {
        alert("Celebration Uploaded");
        setCelebrationFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        await fetchCelebrations();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCelebrationDelete = async (id) => {
    if (!window.confirm("Delete celebration image?")) return;
    try {
      const res = await axios.get(`${BASE_URL}?action=deleteCelebration&id=${id}`);
      if (res.data.status === "deleted") {
        alert("Deleted");
        await fetchCelebrations();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBannerSave = async () => {
    if (!bannerImage) {
      alert("Please select an image");
      return;
    }
    const formData = new FormData();
    formData.append("image", bannerImage);
    formData.append("heading", bannerHeading);
    formData.append("description", bannerDescription);
    try {
      const res = await axios.post(`${BASE_URL}?action=saveHomeBanner`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(res.data);
      if (res.data.status === "success") {
        alert("Banner saved successfully");
        setBannerImage(null);
        await fetchBanner();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBannerUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append("heading", bannerHeading);
      formData.append("description", bannerDescription);
      if (bannerImage) {
        formData.append("image", bannerImage);
      }
      const res = await axios.post(
        `${BASE_URL}?action=updateHomeBanner&id=${banner.id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data.status === "updated") {
        alert("Banner Updated Successfully");
        setBannerImage(null);
        await fetchBanner();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBannerDelete = async () => {
    if (!window.confirm("Delete Banner?")) return;
    try {
      const res = await axios.get(`${BASE_URL}?action=deleteHomeBanner`);
      if (res.data.status === "success") {
        alert("Banner Deleted");
        setBanner(null);
        setBannerHeading("");
        setBannerDescription("");
        setBannerImage(null);
        await fetchBanner();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchImages = async () => {
    try {
      const res = await axios.get(`${BASE_URL}?action=getImages`);
      console.log("Images API:", res.data);
      const imageData = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];
      setImages(imageData);
    } catch (err) {
      console.error(err);
      setImages([]);
      setMessage("❌ Failed to load images");
    }
  };

  const fetchRecentUploads = async () => {
    try {
      const res = await axios.get(`${BASE_URL}?action=getRecentUploads`);
      setRecentUploads([...(Array.isArray(res.data) ? res.data : [])]);
    } catch (err) {
      console.error(err);
      setRecentUploads([]);
    }
  };

  const fetchFaculty = async () => {
    try {
      const res = await axios.get(`${BASE_URL}?action=getFaculty&_=${Date.now()}`);
      setFaculty(Array.isArray(res.data) ? res.data : []);
      setFacultyRefresh(Date.now());
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpload = async () => {
    if (activeTab === "latest") {
      if (!file || (Array.isArray(file) && file.length === 0) || !caption) {
        alert("⚠️ Please select at least one image and enter a caption");
        return;
      }
      const files = Array.isArray(file) ? file : [file];
      for (const f of files) {
        if (!["image/jpeg", "image/png"].includes(f.type)) {
          alert(`⚠️ ${f.name} is not a JPEG/PNG image`);
          return;
        }
        if (f.size > 5 * 1024 * 1024) {
          alert(`⚠️ ${f.name} is larger than 5 MB`);
          return;
        }
      }
    } else {
      if (!file || !category) {
        alert("⚠️ Please select an image and category");
        return;
      }
      if (!["image/jpeg", "image/png"].includes(file.type)) {
        alert("⚠️ Only JPEG or PNG images are allowed");
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        alert("⚠️ File is too large. Max 2 MB allowed");
        return;
      }
    }

    const formData = new FormData();
    if (activeTab === "latest") {
      const files = Array.isArray(file) ? file : [file];
      files.forEach((f) => {
        formData.append("images[]", f);
      });
      formData.append("caption", caption);
      formData.append("category", "home");
    } else {
      formData.append("image", file);
      formData.append("category", category);
      formData.append("caption", "");
    }

    try {
      const actionUrl = activeTab === "latest" ? "uploadMultipleImages" : "uploadImage";
      const res = await axios.post(`${BASE_URL}?action=${actionUrl}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        alert("✅ Uploaded successfully");
        await fetchImages();
        await fetchRecentUploads();
        setFile(null);
        setCaption("");
        setCategory("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        alert("❌ " + (res.data.message || "Unknown error occurred"));
      }
    } catch (err) {
      console.error("Axios Error:", err);
      alert("❌ Server error during upload.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;
    const action = activeTab === "latest" ? "deleteImageUploads" : "deleteImage";
    try {
      const res = await axios.get(`${BASE_URL}?action=${action}&id=${id}`);
      if (res.data.status === "deleted") {
        alert("🗑️ Image deleted");
        await fetchImages();
        await fetchRecentUploads();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = async (id, newCategory) => {
    try {
      const res = await axios.post(`${BASE_URL}?action=updateImage&id=${id}`, {
        category: newCategory,
      });
      if (res.data.status === "updated") {
        alert("✏️ Category updated");
        await fetchImages();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFacultyUpload = async () => {
    if (!facultyFile || !facultyName || !facultyRole || !facultyQualification) {
      alert("⚠️ Fill all required fields");
      return;
    }
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(facultyFile.type)) {
      alert("⚠️ Only JPG, PNG or WEBP images are allowed");
      return;
    }
    if (facultyFile.size > 5 * 1024 * 1024) {
      alert("⚠️ Faculty image too large. Max 5 MB allowed");
      return;
    }

    const formData = new FormData();
    formData.append("image", facultyFile);
    formData.append("name", facultyName);
    formData.append("role", facultyRole);
    formData.append("qualification", facultyQualification);
    formData.append("subject", facultySubject);
    formData.append("description", facultyDescription);
    formData.append("type", facultyType);

    try {
      const res = await axios.post(`${BASE_URL}?action=addFaculty`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        alert("✅ Faculty updated successfully");
        await fetchFaculty();
        setFacultyName("");
        setFacultyRole("");
        setFacultyQualification("");
        setFacultySubject("");
        setFacultyDescription("");
        setFacultyFile(null);
      } else {
        alert(res.data.message || "Upload failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  const handleFacultyUpdate = async (facultyItem) => {
    try {
      const formData = new FormData();
      formData.append("name", facultyItem.name);
      formData.append("role", facultyItem.role);
      formData.append("qualification", facultyItem.qualification);
      formData.append("subject", facultyItem.subject);
      formData.append("description", facultyItem.description);
      formData.append("type", facultyItem.type);
      if (facultyItem.newImage) {
        formData.append("image", facultyItem.newImage);
      }
      const res = await axios.post(
        `${BASE_URL}?action=updateFaculty&id=${facultyItem.id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("Response:", res.data);
      if (res.data.status === "updated") {
        alert("✅ Faculty updated successfully");
        await fetchFaculty();
      } else {
        alert(res.data.message || "Failed to update faculty");
      }
    } catch (err) {
      console.log(err);
      alert("❌ Server error while updating faculty");
    }
  };

  const handleFacultyDelete = async (id) => {
    if (!window.confirm("Delete this faculty?")) return;
    try {
      const res = await axios.get(`${BASE_URL}?action=deleteFaculty&id=${id}`);
      if (res.data.status === "deleted") {
        alert("✅ Faculty deleted successfully");
        fetchFaculty();
      } else {
        alert(res.data.message || "Failed to delete faculty");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Server error while deleting faculty");
    }
  };

  const groupImagesByCaption = (imgs = []) => {
    const grouped = {};
    imgs.forEach((img) => {
      const key = img.caption?.trim() || "No Caption";
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(img);
    });
    return grouped;
  };

  const displayedImages =
    activeTab === "latest"
      ? recentUploads
      : activeTab === "all"
      ? images
      : images.filter((img) => img.category === activeTab);

  return (
    <div style={{ padding: "150px 70px" }}>
      <h1 style={{ display: "flex", justifyContent: "center" }}>Admin Dashboard</h1>
      {message && <p style={{ fontWeight: "bold" }}>{message}</p>}

      <div style={{ marginTop: "40px", display: "flex", gap: "10px", justifyContent: "center" }}>
        {["all", "slider", "swapper", "activity", "latest", "faculty", "celebrations", "homebanner"].map((tab) => (
          <button key={tab} style={tabStyle(activeTab === tab)} onClick={() => setActiveTab(tab)}>
            {tab.toUpperCase()}
          </button>
        ))}
      </div>

      {activeTab === "celebrations" && (
        <div style={{ marginTop: 30, padding: 20, background: "#fff", borderRadius: 10 }}>
          <h2 style={{ display: "flex", justifyContent: "center" }}>Celebrations Management</h2>
          <div style={{ marginBottom: 20, display: "flex", justifyContent: "center" }}>
            <input type="file" accept="image/*" onChange={(e) => setCelebrationFile(e.target.files[0])} />
            <button onClick={handleCelebrationUpload} style={{ marginLeft: 10, padding: "10px 20px", background: "green", color: "#fff", border: "none", cursor: "pointer" }}>
              Upload Celebration
            </button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 20 }}>
            {celebrations.map((item) => (
              <div key={item.id} style={{ border: "1px solid #ddd", padding: 10, borderRadius: 10 }}>
                <img src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/AnnualDayImg/${item.image}`} alt="" style={{ width: "100%", height: 180, objectFit: "cover", borderRadius: 10 }} />
                <button onClick={() => handleCelebrationDelete(item.id)} style={{ width: "100%", marginTop: 10, background: "red", color: "#fff", border: "none", padding: 10, cursor: "pointer" }}>
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab !== "faculty" && activeTab !== "homebanner" && activeTab !== "celebrations" && (
        <div style={{ marginTop: "30px", display: "grid", justifyContent: "center" }}>
          <h3>Upload Image {activeTab === "latest" && "(Select any number of images)"}</h3>
          <div style={{ display: "flex", flexDirection: "column", maxWidth: "300px" }}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={(e) => (activeTab === "latest" ? setFile(Array.from(e.target.files)) : setFile(e.target.files[0]))}
              multiple={activeTab === "latest"}
              style={{ marginBottom: "15px" }}
            />
            {activeTab === "latest" ? (
              <input type="text" placeholder="Enter single caption for all images" value={caption} onChange={(e) => setCaption(e.target.value)} style={{ padding: "8px", marginBottom: "15px" }} />
            ) : (
              <select value={category} onChange={(e) => setCategory(e.target.value)} style={{ padding: "8px", marginBottom: "15px" }}>
                <option value="">Select Category</option>
                <option value="slider">Slider</option>
                <option value="swapper">Swapper</option>
                <option value="activity">Activity</option>
              </select>
            )}
            <button onClick={handleUpload} style={{ padding: "10px", cursor: "pointer", background: "#007bff", color: "#fff", border: "none" }}>
              Upload
            </button>
          </div>
        </div>
      )}

      {activeTab === "homebanner" && (
        <div style={{ marginTop: 40, padding: 25, background: "#fff", borderRadius: 10, boxShadow: "0 0 10px rgba(0,0,0,.1)" }}>
          <h2 style={{ marginBottom: 30 }}>Home Banner Management</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 40 }}>
            <div>
              <h4>Banner Image</h4>
              {bannerImage ? (
                <img src={URL.createObjectURL(bannerImage)} alt="" style={{ width: "100%", height: 260, objectFit: "cover", borderRadius: 10, border: "1px solid #ddd", marginBottom: 15 }} />
              ) : banner && banner.image ? (
                <img
                  src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/${banner.image}`}
                  alt=""
                  style={{ width: "100%", height: 260, objectFit: "cover", borderRadius: 10, border: "1px solid #ddd", marginBottom: 15 }}
                  onError={(e) => { e.target.src = "https://dummyimage.com/900x350/eeeeee/000000&text=Banner+Not+Found"; }}
                />
              ) : (
                <div style={{ width: "100%", height: 260, border: "2px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, marginBottom: 15 }}>
                  No Banner Uploaded
                </div>
              )}
              <input type="file" accept="image/*" onChange={(e) => { if (e.target.files[0]) setBannerImage(e.target.files[0]); }} />
            </div>
            <div>
              <h4>Heading</h4>
              <input type="text" value={bannerHeading} onChange={(e) => setBannerHeading(e.target.value)} placeholder="Heading" style={{ width: "100%", padding: 12, marginBottom: 20 }} />
              <h4>Description</h4>
              <textarea rows={7} value={bannerDescription} onChange={(e) => setBannerDescription(e.target.value)} placeholder="Description" style={{ width: "100%", padding: 12 }} />
              <div style={{ marginTop: 25, display: "flex", gap: 15 }}>
                <button onClick={() => { if (banner) { handleBannerUpdate(); } else { handleBannerSave(); } }} style={{ padding: "12px 25px", background: "green", color: "#fff", border: "none", cursor: "pointer" }}>
                  {banner ? "Update Banner" : "Upload Banner"}
                </button>
                {banner && (
                  <button onClick={handleBannerDelete} style={{ padding: "12px 25px", background: "red", color: "#fff", border: "none", cursor: "pointer" }}>
                    Delete
                  </button>
                )}
              </div>
            </div>
          </div>
          {banner && (
            <div style={{ marginTop: 50, borderTop: "2px solid #ddd", paddingTop: 30 }}>
              <h2>Current Uploaded Banner</h2>
              <img
                src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/${banner.image}`}
                alt=""
                style={{ width: "100%", maxHeight: 350, objectFit: "cover", borderRadius: 10, border: "1px solid #ddd", marginTop: 15 }}
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <div style={{ marginTop: 20, padding: 20, background: "#f7f7f7", borderRadius: 10 }}>
                <h3>{banner.heading}</h3>
                <p style={{ whiteSpace: "pre-wrap", lineHeight: "28px" }}>{banner.description}</p>
                <p><b>Image:</b> {banner.image}</p>
              </div>
            </div>
          )}
        </div>
      )}

      <div style={{ marginTop: "40px" }}>
        {activeTab === "latest" ? (
          <>
            <h3>Latest Updates (Grouped)</h3>
            {Object.keys(groupImagesByCaption(displayedImages)).map((captionKey, idx) => (
              <div key={idx} style={{ marginBottom: "30px", borderBottom: "1px solid #eee", paddingBottom: "20px" }}>
                <h4 style={{ fontWeight: "bold" }}>Caption: {captionKey}</h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                  {groupImagesByCaption(displayedImages)[captionKey].map((img) => (
                    <div key={img.id} style={{ width: "150px", textAlign: "center", border: "1px solid #ddd", padding: "5px" }}>
                      <img src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/${img.image}`} width="100%" alt="upload" />
                      <button onClick={() => handleDelete(img.id)} style={{ background: "red", color: "white", border: "none", cursor: "pointer", marginTop: "5px" }}>Delete</button>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        ) : activeTab === "faculty" ? (
          <div style={{ marginTop: "30px" }}>
            <div style={{ backgroundColor: "#f9f9f9", padding: "25px", borderRadius: "10px", marginBottom: "40px" }}>
              <h3>Add New Faculty</h3>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                <input type="file" onChange={(e) => setFacultyFile(e.target.files[0])} style={{ gridColumn: "1/-1" }} />
                <input type="text" placeholder="Full Name" value={facultyName} onChange={(e) => setFacultyName(e.target.value)} style={inputStyle} />
                <input type="text" placeholder="Role" value={facultyRole} onChange={(e) => setFacultyRole(e.target.value)} style={inputStyle} />
                <input type="text" placeholder="Qualification" value={facultyQualification} onChange={(e) => setFacultyQualification(e.target.value)} style={inputStyle} />
                <input type="text" placeholder="Subject" value={facultySubject} onChange={(e) => setFacultySubject(e.target.value)} style={inputStyle} />
                <select value={facultyType} onChange={(e) => setFacultyType(e.target.value)} style={inputStyle}>
                  <option value="teaching">Teaching Staff</option>
                  <option value="leadership">Leadership/Admin</option>
                </select>
                <textarea placeholder="Description" value={facultyDescription} onChange={(e) => setFacultyDescription(e.target.value)} style={{ ...inputStyle, gridColumn: "1/-1", height: "60px" }} />
              </div>
              <button onClick={handleFacultyUpload} style={{ marginTop: "10px", padding: "10px 20px", background: "#007bff", color: "#fff", border: "none" }}>Add Faculty</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "20px" }}>
              {faculty.map((f) => (
                <div key={f.id} style={{ border: "1px solid #ddd", padding: "10px", borderRadius: "10px" }}>
                  <div style={{ height: "150px", display: "flex", justifyContent: "center", overflow: "hidden", marginBottom: "10px" }}>
                    <img src={f.newImagePreview ? f.newImagePreview : `https://kkblossomschool.org/KKBlossomsWebsite/uploads/FacultyImages/${f.image}?t=${facultyRefresh}`} style={{ height: "100%", objectFit: "contain" }} alt={f.name} />
                  </div>
                  <input type="file" accept="image/*" onChange={(e) => {
                    const file = e.target.files[0];
                    setFaculty((prev) => prev.map((item) => item.id === f.id ? { ...item, newImage: file, newImagePreview: URL.createObjectURL(file) } : item));
                  }} />
                  <input value={f.name} onChange={(e) => setFaculty(faculty.map(item => item.id === f.id ? { ...item, name: e.target.value } : item))} style={cardInputStyle} placeholder="Name" />
                  <input value={f.role} onChange={(e) => setFaculty(faculty.map(item => item.id === f.id ? { ...item, role: e.target.value } : item))} style={cardInputStyle} placeholder="Role" />
                  <input value={f.qualification || ''} onChange={(e) => setFaculty(faculty.map(item => item.id === f.id ? { ...item, qualification: e.target.value } : item))} style={cardInputStyle} placeholder="Qualification" />
                  <input value={f.subject || ''} onChange={(e) => setFaculty(faculty.map(item => item.id === f.id ? { ...item, subject: e.target.value } : item))} style={cardInputStyle} placeholder="Subject" />
                  <input value={f.description || ''} onChange={(e) => setFaculty(faculty.map(item => item.id === f.id ? { ...item, description: e.target.value } : item))} style={cardInputStyle} placeholder="Description" />
                  <button onClick={() => handleFacultyUpdate(f)} style={{ background: "green", color: "white", padding: "5px", width: "48%", marginRight: "4%" }}>Update</button>
                  <button onClick={() => handleFacultyDelete(f.id)} style={{ background: "red", color: "white", padding: "5px", width: "48%" }}>Delete</button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
            {displayedImages.map((img) => (
              <div key={img.id} style={{ border: "1px solid #ddd", padding: "10px", width: "150px", textAlign: "center" }}>
                <img src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/${img.image}`} width="100%" alt="img" />
                <select value={img.category || ""} onChange={(e) => handleUpdate(img.id, e.target.value)} style={{ marginTop: "5px", width: "100%" }}>
                  <option value="slider">Slider</option>
                  <option value="swapper">Swapper</option>
                  <option value="activity">Activity</option>
                </select>
                <button onClick={() => handleDelete(img.id)} style={{ background: "red", color: "white", marginTop: "5px", width: "100%", border: "none" }}>Delete</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const tabStyle = (active) => ({
  padding: "10px 20px",
  cursor: "pointer",
  background: active ? "#007bff" : "#ccc",
  color: active ? "white" : "black",
  borderRadius: "5px",
  border: "none",
  fontWeight: "bold",
});

const inputStyle = { padding: "10px", borderRadius: "5px", border: "1px solid #ccc" };
const cardInputStyle = { padding: "5px", width: "100%", marginBottom: "5px" };

export default AdminDashboard;